import React, { Fragment, memo } from 'react';
import Div from '../Div';
import ChevronRight from '@/components/Icons/ChevronRight';
import classNames from 'classnames';
import Images from '../Image';
import CTAs from './CTAs';
import Paragraph from '../Paragraph';
import Divider from '../Divider';

export interface InformationCardProps {
  dataTestId: string;
  title: string;
  subTitle: string;
  ctas: any[];
  icon: any;
  img?: string;
  className?: string;
  isEMIPlansCard?: boolean;
}

const OfferCard = (props: InformationCardProps) => {
  const { dataTestId, title, subTitle, ctas, icon, img, className, isEMIPlansCard = false } = props;
  return (
    <Div
      dataTestId={dataTestId}
      className={classNames(
        'px-s4 py-s4 border shrink-0 border-solid border-co-subtle rounded-cs bg-cs-primary flex flex-col justify-between	',
        className,
      )}
    >
      <Div className="flex flex-col gap-s2">
        {icon ? icon : <Images src={img} width={32} height={32} className="object-cover" />}

        <Paragraph className="text-h-4 md:text-hd-4 text-cm-primary ">{title}</Paragraph>
        <Paragraph className="text-body-sm md:text-body-base text-cm-primary mt-s2 whitespace-normal">
          {subTitle}
        </Paragraph>
      </Div>

      {isEMIPlansCard ? (
        <Fragment>
          <Divider className="mt-s3 mb-s3" />
          <Div className="flex flex-col gap-s1">
            <Paragraph className="text-body-xs text-green-500">INSTANT 10% OFF</Paragraph>
            <Paragraph className="text-body-xs text-cti-secondary">with select EMI plans</Paragraph>
          </Div>
        </Fragment>
      ) : null}

      <CTAs
        list={ctas || []}
        dataTestId="offer-card"
        className={classNames(
          '!justify-start !gap-s2 inline-flex !pb-0  text-blue-400 text-button-small md:text-button-normal !pt-s4',
        )}
        attribute={
          <Div className="mt-s2">
            <ChevronRight />
          </Div>
        }
      />
    </Div>
  );
};

export default memo(OfferCard);
